import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const TermsConditionsPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-heading text-4xl font-bold mb-8">Terms and Conditions</h1>
        <p className="text-gray-600 mb-8">Last updated: February 2026</p>
        
        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-600 mb-4">
              By accessing and using the Pactac website (pactac.shop), you agree to be bound by these 
              Terms and Conditions. If you do not agree with any part of these terms, please do not 
              use our website.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">2. Products and Pricing</h2>
            <p className="text-gray-600 mb-4">
              All products are subject to availability. We reserve the right to discontinue any product 
              at any time. Prices are displayed in multiple currencies for your convenience, and the 
              final charge will be processed in the currency selected at checkout.
            </p>
            <p className="text-gray-600 mb-4">
              We make every effort to display accurate product information, but we do not warrant that 
              product descriptions, images, or other content is accurate, complete, or error-free.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">3. Orders and Payment</h2>
            <p className="text-gray-600 mb-4">
              By placing an order, you confirm that the information you provide is accurate and that 
              you are authorized to use the payment method selected. All orders are subject to acceptance 
              and availability.
            </p>
            <p className="text-gray-600 mb-4">
              We accept payments through various payment gateways including Stripe, PayPal, Paystack, 
              Flutterwave, and others depending on your region.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">4. Shipping and Delivery</h2>
            <p className="text-gray-600 mb-4">
              Orders are shipped via our trusted shipping partners. Estimated delivery times are 5-8
              business days, but may vary depending on your location and customs processing.
            </p>
            <p className="text-gray-600 mb-4">
              You will receive tracking information via email once your order has been shipped. 
              Pactac is not responsible for delays caused by customs, weather, or other factors 
              beyond our control.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">5. Returns and Refunds</h2>
            <p className="text-gray-600 mb-4">
              We want you to be completely satisfied with your purchase. If you receive a damaged or 
              defective item, please contact us within 7 days of delivery. We will arrange for a 
              replacement or refund.
            </p>
            <p className="text-gray-600 mb-4">
              Due to the nature of international shipping, we generally do not accept returns for 
              change of mind. Please review your order carefully before completing your purchase.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">6. User Accounts</h2>
            <p className="text-gray-600 mb-4">
              You are responsible for maintaining the confidentiality of your account credentials and 
              for all activities that occur under your account. Please notify us immediately if you 
              suspect unauthorized use of your account.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">7. Intellectual Property</h2>
            <p className="text-gray-600 mb-4">
              All content on this website, including text, graphics, logos, images, and software, is 
              the property of Pactac and is protected by intellectual property laws. You may not 
              reproduce, distribute, or create derivative works without our written permission.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-600 mb-4">
              Pactac shall not be liable for any indirect, incidental, special, or consequential 
              damages arising from your use of the website or purchase of products. Our total liability 
              shall not exceed the amount you paid for the product in question.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">9. Governing Law</h2>
            <p className="text-gray-600 mb-4">
              These Terms and Conditions shall be governed by and construed in accordance with the 
              laws of the jurisdiction in which Pactac operates, without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">10. Changes to Terms</h2>
            <p className="text-gray-600 mb-4">
              We reserve the right to modify these Terms and Conditions at any time. Changes will be 
              effective immediately upon posting on this page. Your continued use of the website 
              constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">11. Contact Information</h2>
            <p className="text-gray-600 mb-4">
              For questions about these Terms and Conditions, please contact us at:
            </p>
            <p className="text-gray-600">
              Email: <a href="mailto:hello@pactac.shop" className="text-blue-600 hover:underline">hello@pactac.shop</a>
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
